const state = {
  allServices: [],
  serviceAddedMessage: {},
  iconAddedMessage: {},
  serviceUpdatedMessage: "",
  promotionUpdatedMessage: "",
  promotionAddedMessage: "",
  userServicesById: [],
  userSubscriptionsById: [],
  serviceCategoriesWithServices: [],
  categoryServiceUpdateMessage: "",
  deleteServiceSuccess: "",
  deleteServiceFail: "",
  subCategories: [],
  longDistanceServices: [],
  subscriptionOptions: {},
  filteringParams: {},
  subscriptionReport: {},
  serviceCategoriesTypes: [],
  subscriptionOrdersReport: [],
  recurringOrdersReport: [],
  // total liczy SUBSKRYPCJE, nie wiersze - strona zawiera komplet tygodni swoich subskrypcji,
  // więc recurringOrdersReport.length bywa większe niż on_page.
  recurringOrdersReportPagination: { page_number: 1, on_page: 20, total: 0 },
  recurringOrdersReportFilters: {},
  excludedServicesCategoriesDays: [],
};

const mutations = {
  SET_SERVICES(state, data) {
    state.allServices = data;
  },
  SET_USER_SERVICES_BY_ID(state, data) {
    state.userServicesById = data;
  },
  SET_USER_SUBSCRIPTIONS_BY_ID(state, data) {
    state.userSubscriptionsById = data;
  },
  ADD_SERVICE_SUCCESS(state, data) {
    state.serviceAddedMessage = data;
    setTimeout(() => (state.serviceAddedMessage = ""), 3000);
  },
  ADD_SERVICE_FAIL(state, data) {
    state.serviceAddedMessage = data;
    setTimeout(() => (state.serviceAddedMessage = ""), 3000);
  },
  DELETE_SERVICE_SUCCESS(state, data) {
    state.serviceAddedMessage = data;
  },
  DELETE_SERVICE_FAIL(state, data) {
    state.serviceAddedMessage = data;
  },
  ADD_ICON_SUCCESS(state, data) {
    state.iconAddedMessage = data;
    setTimeout(() => (state.iconAddedMessage = {}), 3000);
  },
  ADD_ICON_FAIL(state, data) {
    state.iconAddedMessage = data;
    setTimeout(() => (state.iconAddedMessage = {}), 3000);
  },
  UPDATE_SERVICE_SUCCESS(state, payload) {
    state.serviceUpdatedMessage = payload;
    setTimeout(() => (state.serviceUpdatedMessage = ""), 3000);
  },
  UPDATE_PROMOTION_SUCCESS(state, payload) {
    state.promotionUpdatedMessage = payload;
    setTimeout(() => (state.promotionUpdatedMessage = ""), 3000);
  },
  ADD_PROMOTION_SUCCESS(state, payload) {
    state.promotionAddedMessage = payload;
    setTimeout(() => (state.promotionAddedMessage = ""), 3000);
  },
  SET_SERVICES_CATEGORIES_WITH_SERVICES(state, payload) {
    state.serviceCategoriesWithServices = payload;
  },
  UPDATE_CATEGORY_SERVICE_SUCCESS(state, payload) {
    state.categoryServiceUpdateMessage = payload;
  },
  DELETE_CATEGORY_SERVICE_SUCCESS(state, payload) {
    state.deleteServiceSuccess = payload;
  },
  DELETE_CATEGORY_SERVICE_FAIL(state, payload) {
    state.deleteServiceFail = payload;
  },
  SET_SUB_CATEGORIES(state, subCategories) {
    state.subCategories = subCategories;
  },
  SET_LONG_DISTANCE_SERVICES(state, payload) {
    state.longDistanceServices = payload;
  },
  SET_SUBSCRIPTION_OPTIONS(state, data) {
    state.subscriptionOptions = data;
  },
  SET_FILTERING_PARAMS(state, data) {
    state.filteringParams = data;
  },
  SET_SUBSCRIPTION_REPORT(state, data) {
    state.subscriptionReport = data;
  },
  SET_SUBSCRIPTION_ORDERS_REPORT(state, data) {
    state.subscriptionOrdersReport = data;
  },
  SET_SERVICE_CATEGORIES_TYPES(state, types) {
    state.serviceCategoriesTypes = types;
  },
  SET_RECURRING_ORDERS_REPORT(state, data) {
    state.recurringOrdersReport = data;
  },
  SET_RECURRING_ORDERS_REPORT_PAGINATION(state, data) {
    state.recurringOrdersReportPagination = data;
  },
  SET_RECURRING_ORDERS_REPORT_FILTERS(state, data) {
    state.recurringOrdersReportFilters = data;
  },
  SET_EXCLUDED_SERVICES_CATEGORIES_DAYS(state, data) {
    state.excludedServicesCategoriesDays = data;
  },
};

const getters = {
  getAllServices: (state) => {
    return state.allServices;
  },
  getAddedServiceMessage: (state) => {
    return state.serviceAddedMessage;
  },
  getIconAddedMessage: (state) => {
    return state.iconAddedMessage;
  },
  getServiceUpdatedMessage: (state) => {
    return state.serviceUpdatedMessage;
  },
  getPromotionUpdatedMessage: (state) => {
    return state.promotionUpdatedMessage;
  },
  getPromotionAddedMessage: (state) => {
    return state.promotionAddedMessage;
  },
  getUserServicesById: (state) => {
    return state.userServicesById;
  },
  getUserSubscriptionsById: (state) => {
    return state.userSubscriptionsById;
  },
  getServiceCategoryWithServices: (state) => {
    return state.serviceCategoriesWithServices;
  },
  getCategoryServiceUpdateMessage: (state) => {
    return state.categoryServiceUpdateMessage;
  },
  getDeleteServiceFail: (state) => {
    return state.deleteServiceFail;
  },
  getDeleteServiceSuccess: (state) => {
    return state.deleteServiceSuccess;
  },
  getAllSubCategories: (state) => {
    return state.subCategories;
  },
  getAllLongDistanceServices: (state) => {
    return state.longDistanceServices;
  },
  getSubscriptionOptions: (state) => {
    return state.subscriptionOptions;
  },
  getFilteringParams: (state) => {
    return state.filteringParams;
  },
  getSubscriptionReport: (state) => {
    return state.subscriptionReport;
  },
  getSubscriptionOrdersReport: (state) => {
    return state.subscriptionOrdersReport;
  },
  getServiceCategoriesTypes: (state) => {
    return state.serviceCategoriesTypes;
  },
  getRecurringOrdersReport: (state) => {
    return state.recurringOrdersReport;
  },
  getRecurringOrdersReportPagination: (state) => {
    return state.recurringOrdersReportPagination;
  },
  getRecurringOrdersReportFilters: (state) => {
    return state.recurringOrdersReportFilters;
  },
  getExcludedServicesCategoriesDays: (state) => {
    return state.excludedServicesCategoriesDays;
  },
};

export default {
  state,
  mutations,
  getters,
};
